// $ExpectTypeSnapshot TypeSnapshotDoNotMatchForVersion
const configB = { a: 15, b: "b" as const, c: "c" };
